/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PushSubscriptionKey } from './PushSubscriptionKey';
import {
    PushSubscriptionKeyFromJSON,
    PushSubscriptionKeyFromJSONTyped,
    PushSubscriptionKeyToJSON,
    PushSubscriptionKeyToJSONTyped,
} from './PushSubscriptionKey';

/**
 * 
 * @export
 * @interface NewPushSubscription
 */
export interface NewPushSubscription {
    /**
     * 
     * @type {string}
     * @memberof NewPushSubscription
     */
    endpoint: string;
    /**
     * 
     * @type {PushSubscriptionKey}
     * @memberof NewPushSubscription
     */
    keys: PushSubscriptionKey;
    /**
     * 
     * @type {number}
     * @memberof NewPushSubscription
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewPushSubscription
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewPushSubscription interface.
 */
export function instanceOfNewPushSubscription(value: object): value is NewPushSubscription {
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    if (!('keys' in value) || value['keys'] === undefined) return false;
    return true;
}

export function NewPushSubscriptionFromJSON(json: any): NewPushSubscription {
    return NewPushSubscriptionFromJSONTyped(json, false);
}

export function NewPushSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewPushSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'],
        'keys': PushSubscriptionKeyFromJSON(json['keys']),
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewPushSubscriptionToJSON(json: any): NewPushSubscription {
    return NewPushSubscriptionToJSONTyped(json, false);
}

export function NewPushSubscriptionToJSONTyped(value?: NewPushSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint': value['endpoint'],
        'keys': PushSubscriptionKeyToJSON(value['keys']),
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
    };
}

